<template>
  <div class="primary-alert-banner d-flex align-items-flex-start">
    <div class="d-flex flex-column content">
      <div class="drip-body title">
        <img
          src="@/assets/images/icons/error-triangle.svg"
          alt="arrow-circle"
          class="image"
          width="16"
          height="16"
        />
        Fraud Alert
      </div>
      <div class="drip-body-small font-weight-400 text">
        Please be vigilant of emails from scammers pretending to be from Drip
        Capital using lookalike domains like
        <a
          href="https://www.dripcepital.com"
          class="text-underline color-noble-blue-500"
          target="_blank"
        >
          dripcepital.com</a
        >,
        <a
          href="https://www.drpcaptal.com"
          class="text-underline color-noble-blue-500"
          target="_blank"
        >
          drpcaptal.com</a
        >, etc. If you receive any emails with payment details or bank
        information from such lookalike domains or from
        <a
          href="https://www.dripcapital.com"
          class="text-underline color-noble-blue-500"
          target="_blank"
        >
          dripcapital.com</a
        >, please contact your Account Manager immediately and email us at
        <a
          href="mailto:payments@dripcapital.com"
          class="text-underline color-noble-blue-500"
          target="_blank"
        >
          payments@dripcapital.com</a
        >. Please always carefully check the sender email ID.
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SecurityAlertBanner'
}
</script>
<style lang="scss" scoped>
.primary-alert-banner {
  background: $orange-50;
  color: $noble-blue-500;
  border: 1px solid $orange-400;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
  .content {
    .title {
      display: flex;
      align-items: center;
      font-weight: 700;
      letter-spacing: 0em;
      text-align: left;
      color: $noble-blue-500;
      margin-bottom: 2px;
      img {
        margin-right: 4px;
      }
    }
    .text {
      letter-spacing: 0em;
      text-align: left;
      color: $noble-blue-500;
    }
    .written {
      line-height: 2;
    }
  }
}
.image {
  display: block;
}

.text-overlay {
  position: absolute;
  top: 54%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: large;
  width: 80px;
  padding-left: 4px;
}

.text-overlay p {
  font-size: 10px;
  font-weight: 700;
  line-height: 13.64px;
  text-align: left;
  color: $noble-blue-500;
  margin: 0;
  text-align: center;
}

@media (min-width: 1024px) {
  .text-overlay {
    top: 50%;
  }
}

@media (min-width: 819px) and (max-width: 1024px) {
  .text-overlay {
    top: 38%;
  }
}

@media (min-width: 425px) and (max-width: 768px) {
  .text-overlay {
    top: 43%;
  }
}
@media (max-width: 425px) {
  .text-overlay {
    top: 34%;
  }
}

@media (min-width: 374px) and (max-width: 424px) {
  .text-overlay {
    top: 31%;
  }
}

@media (min-width: 320px) and (max-width: 374px) {
  .text-overlay {
    top: 25%;
  }
}
</style>
